import { useCustomTypes } from "../../app/services/customTypes"

export function useHasCustomTypes() {
  const customTypes = useCustomTypes().data
  return customTypes.length > 0
}
